<template>
    <div class="modal fade" ref="commentLikeModal" id="comment-like-modal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="pt-4 px-3">
                        <a type="button" class="modal-close-btn" data-dismiss="modal">
                            <img src="/images/global/close-icon.svg">
                        </a>
                        <div class="modal-heading">Likes</div>
                        <ul id="comment-like-list" class="list-group list-group-flush">
                            <li v-for="like in commentLikes" class="list-group-item">{{ like.employee.first_name }} {{ like.employee.last_name }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        open: {
            type: Boolean,
            default: false
        },
        commentLikes: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    mounted() {
        $(this.$refs.commentLikeModal).on('hide.bs.modal', () => this.$emit('commentLikeListModalClosed'));
    },
    watch: {
        open(newValue) {
            if (newValue) {
                $(this.$refs.commentLikeModal).modal('show');
            }
        }
    }
}
</script>
